import ChevronDownIcon from "@redotech/redo-icons/chevron-down_filled.svg";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import {
  RedoCommandMenu,
  type RedoCommandMenuItem,
} from "@redotech/redo-web/arbiter-components/command-menu/redo-command-menu";
import { Flex } from "@redotech/redo-web/flex";
import { memo, useMemo, useState } from "react";
import { type UseReplyModeResult, replyModes } from "../hooks/use-reply-mode";

export const ReplyModeDropdown = memo(function ReplyModeDropdown({
  replyModeState,
}: {
  replyModeState: UseReplyModeResult;
}) {
  const { activeReplyAction, replyModeActions, setReplyMode } = replyModeState;

  const [open, setOpen] = useState(false);
  const [anchorRef, setAnchorRef] = useState<HTMLButtonElement | null>(null);

  const items: RedoCommandMenuItem[] = useMemo(
    () =>
      replyModes.map((mode) => ({
        Icon: replyModeActions[mode].Icon,
        text: replyModeActions[mode].title,
        onClick: () => setReplyMode(mode),
      })),
    [replyModeActions, setReplyMode],
  );

  return (
    <Flex p="sm" pb="none">
      <RedoButton
        hierarchy="tertiary"
        IconLeading={activeReplyAction.Icon}
        IconTrailing={ChevronDownIcon}
        onClick={() => setOpen((prev) => !prev)}
        ref={setAnchorRef}
        size="sm"
        text={activeReplyAction.title}
      />
      <RedoCommandMenu
        anchor={anchorRef}
        items={items}
        open={open}
        placement="bottom-start"
        setOpen={setOpen}
      />
    </Flex>
  );
});
